import { Entry } from '../Entry'

export function Entry20230927() {
  return (
    <Entry title="Sep 27 2023 - v3.5.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13973/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
